import React, { memo } from "react"
import { useSelector } from "react-redux"
import { makeStyles } from "@material-ui/core/styles"
import Box from "@material-ui/core/Box"
import ControlPanelSidebarFormContent from "@/components/control-panel/control-panel-form"
import ControlPanelSidebarCollapse from "./ControlPanelSidebarCollapse"
import ControlPanelSidebarActions from "./ControlPanelSidebarActions"

const useStyles = makeStyles((theme) => ({
    controlPanelSidebarCollapse: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(22,22,23,.2)",
        [theme.breakpoints.up("md")]: {
            flexDirection: "row",
        },
    },
    controlPanelSidebarActions: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    controlPanelSidebarFormContent: {
        minWidth: "263px",
        flexBasis: "263px",
    },
}))

const ControlPanelSidebar = memo((props) => {
    const { handleModalCompleteProjectShowChange } = props
    const classes = useStyles()
    const controlPanelSidebarStatus = useSelector((state) => state.controlPanelSidebarReducer)

    return (
        <>
            <Box className={classes.controlPanelSidebarCollapse}>
                <ControlPanelSidebarCollapse />
            </Box>
            {controlPanelSidebarStatus && !controlPanelSidebarStatus.close ? (
                <>
                    <Box className={classes.controlPanelSidebarActions}>
                        <ControlPanelSidebarActions handleModalCompleteProjectShowChange={handleModalCompleteProjectShowChange} />
                    </Box>
                    <Box className={classes.controlPanelSidebarFormContent}>
                        <ControlPanelSidebarFormContent handleModalCompleteProjectShowChange={handleModalCompleteProjectShowChange} />
                    </Box>
                </>
            ) : (
                <Box className={classes.controlPanelSidebarActions}>
                    <ControlPanelSidebarActions handleModalCompleteProjectShowChange={handleModalCompleteProjectShowChange} />
                </Box>
            )}
        </>
    )
})

export default ControlPanelSidebar
